export class RegiaoAdministrativa {

    id: number;
    numero: string;
    nome: string;
}